import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Observable, startWith, map } from 'rxjs';
import { RootScopeService } from 'src/app/services/root-scope.service';

@Component({
  selector: 'app-admin-filter',
  templateUrl: './admin-filter.component.html',
  styleUrls: ['./admin-filter.component.scss']
})
export class AdminFilterComponent implements OnInit {

  /* istanbul ignore next */
  // range -- getting start & end Date from datepicker
  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  maxDate!: Date;
  minDate = this.range.value.start;
  // @ViewChild(InteractionHistoryListViewComponent) listViewComponent;
/* istanbul ignore next */
  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.minDate = this.range.value.start;
  }

/* istanbul ignore next */
  iconConfig: { iconName: string; iconType: string; };
  
  separatorKeysCodes: number[] = [ENTER, COMMA];
  titleValue = new FormControl('');
  topicValue = new FormControl('');
  descriptionValue = new FormControl('');
  filteredTitle: Observable<string[]>;
  filteredTopic: Observable<string[]>;
  filteredDescription: Observable<string[]>;
  selectedTitles: string[] = [];
  selectedTopics: string[] = [];
  selectedDescriptions: string[] = [];
  allTitles: string[] = ['Title1', 'Title2', 'Title3'];
  allTopics: string[] = ['Topic1', 'Topic2', 'Topic3'];
  allDescriptions: string[]=['Description1', 'Description2', 'Description3']
/* istanbul ignore next */
@ViewChild('topicInput') topicInput!: ElementRef<HTMLInputElement>;
@ViewChild('titleInput') titleInput!: ElementRef<HTMLInputElement>;
@ViewChild('descriptionInput') descriptionInput!: ElementRef<HTMLInputElement>;

  constructor(public rootScope: RootScopeService, public dialog: MatDialog,) { 
    this.iconConfig = {
      iconName: 'times',
      iconType: 'fal'
    }
/* istanbul ignore next */
    this.filteredTopic = this.topicValue.valueChanges.pipe(
      startWith(null),
      map((topic: string | null) => (topic ? this.filterTopicList(topic) : this.allTopics.slice())),
    );
/* istanbul ignore next */
    this.filteredTitle = this.titleValue.valueChanges.pipe(
      startWith(null),
      map((title: string | null) => (title ? this.filterTitleList(title) : this.allTitles.slice())),
    );

    /* istanbul ignore next */
    this.filteredDescription = this.descriptionValue.valueChanges.pipe(
      startWith(null),
      map((description: string | null) => (description ? this.filterDescriptionList(description) : this.allDescriptions.slice())),
    );
  }

  ngOnInit(): void {
  }
/* istanbul ignore next */
closeFilter() {
  this.rootScope.openAdminFilterDialog = false;
}
/* istanbul ignore next */
addTopic(event: MatChipInputEvent): void {
  const value = (event.value || '').trim();

  // Add our fruit
  if (value) {
    this.selectedTopics.push(value);
  }

  // Clear the input value
  event.chipInput!.clear();

  this.topicValue.setValue(null);
}
/* istanbul ignore next */
addTitle(event: MatChipInputEvent): void {
  const value = (event.value || '').trim();

  // Add our fruit
  if (value) {
    this.selectedTitles.push(value);
  }

  // Clear the input value
  event.chipInput!.clear();

  this.titleValue.setValue(null);
}

/* istanbul ignore next */
addDescription(event: MatChipInputEvent): void {
  const value = (event.value || '').trim();

  // Add our fruit
  if (value) {
    this.selectedDescriptions.push(value);
  }

  // Clear the input value
  event.chipInput!.clear();

  this.descriptionValue.setValue(null);
}
/* istanbul ignore next */
selectedTopic(event: MatAutocompleteSelectedEvent): void {
  this.selectedTopics.push(event.option.viewValue);
  this.topicInput.nativeElement.value = '';
  this.topicValue.setValue(null);
}
/* istanbul ignore next */
selectedTitle(event: MatAutocompleteSelectedEvent): void {
  this.selectedTitles.push(event.option.viewValue);
  this.titleInput.nativeElement.value = '';
  this.titleValue.setValue(null);
}
/* istanbul ignore next */
selectedDescription(event: MatAutocompleteSelectedEvent): void {
  this.selectedDescriptions.push(event.option.viewValue);
  this.descriptionInput.nativeElement.value = '';
  this.descriptionValue.setValue(null);
}
/* istanbul ignore next */
removeTopic(topic: string): void {
  const index = this.selectedTopics.indexOf(topic);

  if (index >= 0) {
    this.selectedTopics.splice(index, 1);
  }
}
/* istanbul ignore next */
removeTitle(title: string): void {
  const index = this.selectedTitles.indexOf(title);

  if (index >= 0) {
    this.selectedTitles.splice(index, 1);
  }
}
/* istanbul ignore next */
removeDescription(description: string): void {
  const index = this.selectedDescriptions.indexOf(description);

  if (index >= 0) {
    this.selectedDescriptions.splice(index, 1);
  }
}
/* istanbul ignore next */
private filterTopicList(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.allTopics.filter(topic => topic.toLowerCase().includes(filterValue));
}
/* istanbul ignore next */
private filterTitleList(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.allTitles.filter(title => title.toLowerCase().includes(filterValue));
}

/* istanbul ignore next */
private filterDescriptionList(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.allDescriptions.filter(description => description.toLowerCase().includes(filterValue));
}

}
